import React from 'react';
import { Row, Col } from 'reactstrap';

interface IGlossaryItem {
  term: string;
  definition: string;
}

interface IGlossarySectionProps {
  items: IGlossaryItem[];
}

const GlossarySection: React.FC<IGlossarySectionProps> = ({ items }) => {
  const midpoint = Math.ceil(items.length / 2);
  const leftColumn = items.slice(0, midpoint);
  const rightColumn = items.slice(midpoint);

  return (
    <div className="kh-glossary">
      <Row>
        <Col md={6} lg={6}>
          {leftColumn.map((item, index) => (
            <div key={index} className="kh-glossary__item">
              <h4 className="kh-glossary__term">{item.term}</h4>
              <p className="kh-glossary__definition">{item.definition}</p>
              {index < leftColumn.length - 1 && <div className="kh-glossary__separator" />}
            </div>
          ))}
        </Col>
        <Col md={6} lg={6}>
          {rightColumn.map((item, index) => (
            <div key={index} className="kh-glossary__item">
              <h4 className="kh-glossary__term">{item.term}</h4>
              <p className="kh-glossary__definition">{item.definition}</p>
              {index < rightColumn.length - 1 && <div className="kh-glossary__separator" />}
            </div>
          ))}
        </Col>
      </Row>
    </div>
  );
};

export default GlossarySection;
